import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './FileUploader.html?raw';
import '../../../moreCore/UI/GenericDialog/GenericDialog';
import FileUpload from '../../../moreCore/UI/Filetransfer/FileUpload/FileUpload';
import email_UploadedFilesDisplay from './uploadedFilesDisplay';
import RequestManager from 'more/RequestManager';
import { EmailEditorTypes } from "../emailTypes";
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { FileUploadTypes } from "../../../moreCore/UI/Filetransfer/FileUpload/FileUploadTypes";

class email_FileUploader extends compose(_WidgetBaseSP) {
    templateString: any = template;

    fileUploadContainer:HTMLDivElement;
    fileUploader: MdsLax<InstanceType<typeof FileUpload>>;

    upFilesMenuWidget:MdsLax<InstanceType<typeof email_UploadedFilesDisplay>>;

    reqMgr:RequestManager;

    postCreate() {
        this.fileUploader = new FileUpload(null);
        this.fileUploader.useDisplay = false;
        this.fileUploader.setMultiUpload(true);
        this.fileUploader.placeAt(this.fileUploadContainer);
        this.fileUploader.on("complete", lang.hitch(this, this._onComplete_FileUploader));
        //setzt events fuer uploadedFiles widget
        this.upFilesMenuWidget.on("newFile", lang.hitch((newFile: EmailEditorTypes.MailDataFile) => {
            this.emit("newFile", newFile);
        }));
        this.upFilesMenuWidget.on("removedFile", lang.hitch((fileID: string) => {
            this.emit("removedFile", fileID);
        }));
    }

    private async _onComplete_FileUploader(guid:string){
        let targetGuid = guid;
        let fileData: Array<FileUploadTypes.UploadUnit> = this.fileUploader.getValue();
        let newFile: EmailEditorTypes.mailFileUploadToConvert = {
            guid: targetGuid,
            filename: ""
        };
        for (let dat of fileData){
            if (targetGuid == dat.guid){
                newFile.filename = dat.filenames[0];
            }
        }
        try{
            let res = await this.APIconvertUploadedFile(newFile);
            if (typeof res == 'boolean'){
                throw "Error converting uploaded file!";
            }
            this.upFilesMenuWidget.addFileButton(res["filename"], res["ID"]);
            //anmerkung: wir muessen nichts emiten, da upFileMenuWidget bereits emited
        }catch{
            this.displayPopupMsg({ msg: this.translations["email_fileUpload_onError_convertingUploadedFile"], isError: true, isWarning: false });
            console.error("error converting uploaded file");
            return;
        }

    }

    public async APIconvertUploadedFile(uploadData: EmailEditorTypes.mailFileUploadToConvert) {
        let postData = JSON.stringify(uploadData);
        postData = postData;
        let apiURL = window.appRoot + "EMail/ConvertFileUpload";
        return new Promise((resolve, reject) => {
            this.reqMgr.post(apiURL, { mailDataJson: postData },
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(false);
                }
            ),
            null
        });
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    public getRecordState() {
        return this.upFilesMenuWidget.getRecordState();
    }

    public setRecordState(rec: any) {
        this.upFilesMenuWidget.setRecordState(rec);
    }

    public addFile(filename: string, guid: string) {
        this.upFilesMenuWidget.addFileButton(filename, guid);
    }

    private displayPopupMsg(ev: { msg: string, isError: boolean, isWarning: boolean }) {
        this.emit("displayPopupMsg", ev);
    }

}

mdsLazyProto(email_FileUploader.prototype, {
  reqMgr: () => (new RequestManager()),
});
export default mdsWidget(email_FileUploader);
